import { ArrayUtils } from '@shopping/common'
import { axios } from 'common/utils'
import { SubVertical } from 'common/constants'
import { BrandIndexType, BrandInitialIndexType } from 'common/constants/brand'
import { BrandAggregate } from 'common/types/entities/mongo/brandAggregate'
import { BrandIndexList, NaverShoppingBrand } from 'common/types/entities/api/brand'
import { Brand } from 'common/types/entities/mongo/brand'
import logger from 'common/logger'

const BASE_URL = '/v1/brands'

export async function fetchBrandSuggestions(subVertical: SubVertical, keyword: string): Promise<BrandAggregate[]> {
  if (!keyword) return
  const result = await axios.get<BrandAggregate[]>(`${BASE_URL}/subvertical/${subVertical}/suggestions`, {
    params: { keyword },
  })
  return result && result.data
}

export async function fetchBrandByIndex(
  subVertical: SubVertical,
  initialIndexType: BrandInitialIndexType,
): Promise<BrandAggregate[]> {
  const result = await axios.get<BrandAggregate[]>(`${BASE_URL}/subvertical/${subVertical}/initial`, {
    params: { initialIndexType },
  })
  return result && result.data
}

export async function fetchBrandIndexList(
  subVertical: SubVertical,
  indexType: BrandIndexType,
): Promise<BrandIndexList> {
  if (!indexType) return
  const result = await axios.get<BrandIndexList>(`${BASE_URL}/subvertical/${subVertical}/indexes/${indexType}`)
  return result && result.data
}

export async function fetchBrandsByMenuId(menuId: string) {
  if (!menuId) return
  const result = await axios.get<BrandAggregate[]>(`${BASE_URL}/menu/${menuId}`)
  return result && result.data
}

export async function fetchBrandsByIds(subVertical: SubVertical, brandIds: string[]) {
  if (ArrayUtils.isEmpty(brandIds)) return

  const result = await axios.get<BrandAggregate[]>(`${BASE_URL}/subvertical/${subVertical}`, {
    params: {
      brandIds,
    },
  })
  return result && result.data
}

export const fetchBrand = async (brandId: string): Promise<Brand> => {
  const response = await axios.get<Brand>(`/v1/brands/${brandId}`)
  return response && response.data
}

export const fetchNaverShoppingBrands = async (type: string, key: string) => {
  const response = await axios.get<NaverShoppingBrand[]>(`${BASE_URL}/type/${type}/key/${encodeURIComponent(key)}`)
  return response && response.data
}
